import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import SiteCardItem from "./SiteCardItem";

function SiteCardItemList({ sites }) {
  return (
    <div>
      <Grid container spacing={3}>
        {sites &&
          sites.map((site) => (
            <Grid item xs={12} md={4}>
              <SiteCardItem key={site._id} site={site} />
            </Grid>
          ))}
      </Grid>
    </div>
  );
}

SiteCardItemList.propTypes = {
  sites: PropTypes.array,
};

export default SiteCardItemList;
